'use client';
import { useTranslations } from 'next-intl';

import { BasicProductDataResponse } from '@/types/catalog';
import { ProductCard } from '@/app/[locale]/stores/[storeId]/product/components/ProductCard';

export const SimilarProducts = ({
  similarProductsInfo,
  branchId,
}: {
  similarProductsInfo?: (BasicProductDataResponse & {
    integrationId: string;
  })[];
  branchId: string | number;
}) => {
  const t = useTranslations('product');

  return (
    <section className="mx-auto max-w-[1440px] py-5">
      <h2 className="mt-1 mb-5 text-xl font-bold capitalize">{t('similar products')}</h2>
      <div className="styled-scroll flex flex-nowrap gap-5 overflow-auto px-2 pb-3 transition-all duration-300">
        {similarProductsInfo?.map((item, index) => (
          <div key={index} className="shrink-0 basis-1/2 sm:basis-1/3 md:basis-1/4 lg:basis-1/5">
            <ProductCard productDetails={item} scroll branchId={branchId} />
          </div>
        ))}
      </div>
    </section>
  );
};
